import { Button, Form } from "antd";
import { useCreateDocumentTag } from "../hooks/useCreateDocumentTag";
import ViagsModalForm from "../../../../../components/viags-modal-form/viags-modal-form";
import { DocumentTagsFormItem } from "./document-tags-form-items";

const AddDocumentTagModalForm = () => {
  const [form] = Form.useForm();
  const { createDocumentTag, isLoading } = useCreateDocumentTag();

  const handleAddDocumentTag = (values: { Title: string; eTagType: string }) => {
    const fields = { ...values };
    createDocumentTag(fields);
    form.resetFields();
    return true;
  };

  return (
    <ViagsModalForm
      trigger={
        <Button type="primary" disabled={isLoading}>
          Thêm chủ đề
        </Button>
      }
      modalProps={{ title: "Thêm chủ đề", width: 688, destroyOnClose: true }}
      form={form}
      size="large"
      labelCol={{ span: 6 }}
      layout="horizontal"
      onFinish={(values: { Title: string; eTagType: string }) => handleAddDocumentTag(values)}
    >
      <DocumentTagsFormItem />
    </ViagsModalForm>
  );
};

export default AddDocumentTagModalForm;
